module.exports = __webpack_public_path__ + "img/错号.9aa5b70f.svg";